import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MuiLink from '@mui/material/Link';
import Section from './Section';

const SHADOW = '3px 3px 0px #1e1e1e';

const PRIVACY_POINTS = [
  {
    icon: '🛡',
    title: 'Student Privacy by Design',
    description: 'Personally identifiable information is removed before any AI interaction. Student PII is never sent to AI systems.',
  },
  {
    icon: '✅',
    title: 'FERPA & COPPA Enforced',
    description: 'Compliance is enforced technically, not just procedurally. Built-in safeguards at every layer.',
  },
  {
    icon: '👩\u200D🏫',
    title: 'Teacher-Moderated AI',
    description: 'Teachers can enable or disable AI features and monitor all student interactions in real time.',
  },
  {
    icon: '🏫',
    title: 'District Control & Security',
    description: 'Role-based access, encrypted data, administrative oversight, and the ability to disable AI or delete data at any time.',
  },
];

export default function PrivacySection() {
  return (
    <Section background="#2C2C2C" dark>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: { xs: 4, md: 8 },
          alignItems: 'center',
        }}
      >
        <Box>
          <Typography
            variant="h2"
            sx={{
              fontFamily: 'Montserrat, Inter, sans-serif',
              fontSize: { xs: '1.75rem', md: '2.25rem' },
              fontWeight: 800,
              mb: 2,
            }}
          >
            AI Without Compromise on Privacy
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Lato, Inter, sans-serif',
              fontSize: '1.05rem',
              color: 'rgba(255,255,255,0.75)',
              lineHeight: 1.7,
              mb: 3,
            }}
          >
            Our AI operates only on anonymized instructional content. We believe powerful learning tools and student privacy aren&apos;t
            mutually exclusive.
          </Typography>
          <MuiLink
            href="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            sx={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '0.9rem',
              color: '#FFE082',
              fontWeight: 700,
              '&:hover': { color: '#FFF59D' },
            }}
          >
            Read our Privacy Policy &rarr;
          </MuiLink>
        </Box>

        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2.5 }}>
          {PRIVACY_POINTS.map((point) => (
            <Box
              key={point.title}
              sx={{
                p: 2.5,
                borderRadius: '6px',
                backgroundColor: '#FFFFFF',
                border: '2px solid #1e1e1e',
                boxShadow: SHADOW,
                color: '#2C2C2C',
              }}
            >
              <Typography sx={{ fontSize: '1.5rem', mb: 1 }}>{point.icon}</Typography>
              <Typography sx={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '0.85rem', mb: 0.5 }}>
                {point.title}
              </Typography>
              <Typography sx={{ fontFamily: 'Lato, sans-serif', fontSize: '0.75rem', color: '#666', lineHeight: 1.6 }}>
                {point.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Section>
  );
}
